import { Swiper, Navigation, Pagination, Scrollbar, Thumbs} from "swiper";
let spaceBetweenResp = 20;
let slidesPerViewResp = 3;
if (window.innerWidth >= 992) {
  spaceBetweenResp = 30;
  slidesPerViewResp = 4;
}
if (window.innerWidth >= 1200) {
  spaceBetweenResp = 40;
  slidesPerViewResp = 6;
}

const thumbsSwiper = new Swiper('.thumbsSwiper', {
    modules: [Navigation, Pagination, Scrollbar, Thumbs],
    speed: 400,
    spaceBetween: spaceBetweenResp,
    slidesPerView: slidesPerViewResp,
    freeMode: true,
    watchSlidesProgress: true,  
    scrollbar: {
        el: '.thumbsSwiper .swiper-scrollbar',
        draggable: true,
      },
});
const swiperGallery = new Swiper('.gallery', {
    modules: [Navigation, Pagination, Scrollbar, Thumbs],
    speed: 400,
    spaceBetween: 0,
    navigation: {
      nextEl: ".gallery .swiper-button-next",
      prevEl: ".gallery .swiper-button-prev",
    },
    thumbs: {
        swiper: thumbsSwiper,
        draggable: true,
    }
});